const BehindTheScenes = () => {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-teedee-blue mb-4">
            Created in the Cayman Islands
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Born from a passion to create authentic, educational content that
            reflects the beauty and values of our island home.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="p-4 bg-gray-50 rounded-2xl shadow-xl">
            {" "}
            {/* Updated container */}
            <img
              src="/img/bobo-teedee-logo.png?w=600&h=400&fit=crop"
              alt="Beautiful Cayman Islands beach scene that inspired Bobo & Teedee®"
              className="w-full h-80 object-contain rounded-lg" // Updated classes
            />
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="text-2xl font-bold text-teedee-blue mb-3">
                Our Story
              </h3>
              <p className="text-gray-600 mb-4">
                Bobo & Teedee® was created by a team of local educators,
                animators, and cultural enthusiasts who wanted to give Cayman
                Islands children characters they could see themselves
                in—characters who looked like them, lived where they lived, and
                celebrated their unique culture.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-bobo-green mb-3">
                Our Vision
              </h3>
              <p className="text-gray-600 mb-4">
                We envision a world where every child feels proud of their
                heritage while learning universal values that help them become
                kind, thoughtful, and engaged global citizens.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-brand-purple mb-3">
                Our Impact
              </h3>
              <p className="text-gray-600">
                Since our launch, Bobo & Teedee® has reached thousands of
                children across the Caribbean and beyond, helping them connect
                with Cayman Islands culture while learning important life
                lessons.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BehindTheScenes;
